module.exports = __webpack_public_path__ + "img/moc-lockup.6ee4442f.svg";